var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"upload__title"},[_vm._v("Upload your design")]),_c('drag-and-drop-uploader',{on:{"change":_vm.updateFile}}),(!_vm.image)?_c('div',[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"accepted__types"},[_vm._v(" Accepted File Types: "),_c('br'),_vm._v(" JPG, JPEG, PNG, BMP, PDF - 5MB Max. ")])
}]

export { render, staticRenderFns }